import { NgModule } from 'ng-metadata/core';
import { CheckoutConfirmationProgressDirective } from './confirmation.directive';

@NgModule({
  declarations: [
    CheckoutConfirmationProgressDirective,
  ],
})
export class CheckoutConfirmationModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/confirmation/confirmation.module.ts